<template>
  <div class="map wow fadeInDown">
  <div class="zy-container " style="margin-top: 40px;">
    <TitleDesc title="合作企业"
               desc="覆盖电商、出行、短视频、企业服务等众多领域"/>

  </div>
  <el-image :src="require('@/assets/images/index/custom.png')" fit="scale-down" >
  </el-image>
  </div>
</template>

<script>
import TitleDesc from "@/views/index/widgets/TitleDesc.vue";
import { WOW } from "wowjs";

export default {
  name: "Custom",
  components: {TitleDesc},
  mounted() {
    this.$nextTick(() => {
      new WOW().init()
    })
  },
  data() {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.map {
}
</style>
